import React, { useState, useEffect, ReactElement } from 'react';
import { LocationSummaryData } from '../types';
import LocationSummaryTile from './Tiles/LocationSummaryTile';
import './LocationsList.scss';

interface LocationsListProps {
    locations: LocationSummaryData[];
    onLocationChange: (id: number) => void;
}

const LocationsList = ({ locations, onLocationChange }: LocationsListProps): ReactElement => {

    const [activeLocationId, setActiveLocationId] = useState<number>(0);

    useEffect(() => {
        // Set the first location as active by default - if available
        if (locations.length > 0) {
            setActiveLocationId(locations[0].id);
            onLocationChange(locations[0].id);
        }
    }, [locations]);

    const onLocationClick = (id: number) => {
        setActiveLocationId(id);
        onLocationChange(id);
    };

    return (
        <div className='overview-locations-list'>
            {locations.map((location) => (
                <LocationSummaryTile
                    key={location.id}
                    location={location}
                    onClick={() => onLocationClick(location.id)}
                    isActive={activeLocationId === location.id}
                />
            ))}
        </div>
    );
};

export default LocationsList;
